import React from "react";
import '../../App.css'

export default function Events(){
    return <h1 className="events">EVENTS</h1>;
    
}